import React from 'react';
import { Modal } from '@mui/material';
import { useTranslation } from 'react-i18next';
import {
  DeleteModalContainer,
  DeleteModalContent,
  DeleteModalTitle,
  DeleteModalTitleHighlight,
  DeleteModalButtonGroup,
  DeleteModalCancelButton,
  DeleteModalConfirmButton,
} from './ConsultationDeleteStyledModal';

const ConsultationDeleteModal = ({ open, onClose, onConfirm }) => {
  const { t } = useTranslation();

  const handleConfirm = () => {
    onConfirm?.();
    onClose();
  };

  return (
    <Modal open={open} onClose={onClose}>
      <DeleteModalContainer>
        <DeleteModalContent>
          <DeleteModalTitle>
            {t('정말로 ')}
            <DeleteModalTitleHighlight>{t('삭제')}</DeleteModalTitleHighlight>
            {t('하시겠습니까?')}
          </DeleteModalTitle>
        </DeleteModalContent>

        <DeleteModalButtonGroup>
          <DeleteModalCancelButton onClick={onClose}>
            {t('닫기')}
          </DeleteModalCancelButton>
          <DeleteModalConfirmButton onClick={handleConfirm}>
            {t('삭제')}
          </DeleteModalConfirmButton>
        </DeleteModalButtonGroup>
      </DeleteModalContainer>
    </Modal>
  );
};

export default ConsultationDeleteModal;
